import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import register from './registerServiceWorker';
import FirefoxPage from './FirefoxPage';

const root = createRoot(document.getElementById('root'));

// Check if broswer is Firefox
if (typeof InstallTrigger !== 'undefined') {
  root.render(<FirefoxPage />);
} else {
  root.render(<App />);
  register(); // @see https://gitlab.com/eurofours/etools/-/issues/426
}
